<template>
  <div class="bottom-tab-bar-wrapper">
    <div class="bottom-tab-bar">
      <div
        v-for="item in tabList"
        :key="item.id"
        class="tab-item"
        :class="{ active: activeTab === item.id }"
        @click="handleTabClick(item)"
      >
        <IconSvg :icon="item.icon" :size="20" :color=" activeTab == item.id ? 'rgba(255,255,255,1)':'rgba(255,255,255,0.6)'" />
        <span class="tab-title">{{ item.title }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { showToast } from 'vant'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

interface TabItem {
  id: string
  icon: string
  title: string
  path: string
}

interface Props {
  modelValue?: string
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: 'home'
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'tab-click', item: TabItem): void
}>()

const router = useRouter()

const activeTab = ref(props.modelValue)

const tabList = ref<TabItem[]>([
  { id: 'home', icon: 'icon-shouye', title: '首页', path: '/home' },
  // { id: 'knowledge', icon: 'icon-fenlei', title: '配号方案', path: '' },
  { id: 'special-feature', icon: 'icon-shoucangjia', title: '特色专区', path: '/special-feature' },
  // { id: 'equipment', icon: 'icon-shoucangjia', title: '装备', path: '/equipment' },
  { id: 'profile', icon: 'icon-icon-test', title: '我的', path: '/profile' },

])


function handleTabClick(item: TabItem) {
  if(item.path == ''){
    showToast('正在开发中')
    return
  }
  activeTab.value = item.id
  emit('update:modelValue', item.id)
  emit('tab-click', item)

  if (item.path) {
    router.push(item.path)
  }
}
</script>

<style lang="scss" scoped>

.bottom-tab-bar-wrapper {
  position: fixed;
  bottom: 16px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  z-index: 1000;
}

.bottom-tab-bar {
  width: calc(100% - 32px);
  max-width: 400px;
  height: 60px;
  background-color: $primary-color;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 8px;
  box-shadow: 0 4px 16px rgba($primary-color, 0.4);

  .tab-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    flex: 1;
    padding: 8px 4px;

    .tab-icon {
      font-size: 24px;
      color: rgba($white, 0.6);
      margin-bottom: 2px;
      transition: all 0.3s ease;
    }

    .tab-title {
      font-size: 12px;
      color: rgba($white, 0.6);
      transition: all 0.3s ease;
    }

    &.active {
      .tab-icon {
        color: $white;
        transform: scale(1.1);
      }

      .tab-title {
        color: $white;
        font-weight: 500;
      }
    }
  }
}
</style>
